"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  Lock1: ['lock-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.5,9.5h-.75V6.75a6.75,6.75,0,0,0-13.5,0V9.5H4.5a2,2,0,0,0-2,2V22a2,2,0,0,0,2,2h15a2,2,0,0,0,2-2V11.5A2,2,0,0,0,19.5,9.5Zm-9.5,6a2,2,0,1,1,3,1.723V19.5a1,1,0,0,1-2,0V17.223A1.994,1.994,0,0,1,10,15.5ZM7.75,6.75a4.25,4.25,0,0,1,8.5,0V9a.5.5,0,0,1-.5.5H8.25a.5.5,0,0,1-.5-.5Z']],
  KeyholeCircle: ['keyhole-circle', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm2.5,18.131a.5.5,0,0,1-.493.572H9.712a.5.5,0,0,1-.49-.594l1.255-5.86A3.429,3.429,0,0,1,11.17,5.8,3.493,3.493,0,0,1,15.5,9.15a3.439,3.439,0,0,1-1.978,3.1Z']],
  KeyholeSquare: ['keyhole-square', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.857,0H2.143A2.145,2.145,0,0,0,0,2.143V21.858A2.145,2.145,0,0,0,2.143,24H21.857A2.145,2.145,0,0,0,24,21.858V2.143A2.145,2.145,0,0,0,21.857,0ZM14.5,17.928a.5.5,0,0,1-.493.572H9.712a.5.5,0,0,1-.49-.594l1.255-5.86a3.429,3.429,0,0,1,.693-6.452A3.492,3.492,0,0,1,15.5,8.946a3.44,3.44,0,0,1-1.978,3.1Z']],
  Lock6: ['lock-6', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.75,10.063V6.748a6.75,6.75,0,0,0-13.5,0v3.315A4.986,4.986,0,0,0,2.5,14.5V19a5.005,5.005,0,0,0,5,5h9a5.005,5.005,0,0,0,5-5V14.5A4.986,4.986,0,0,0,18.75,10.063ZM14,16.452a2,2,0,1,1-2-2A2,2,0,0,1,14,16.452ZM12,2.5a4.255,4.255,0,0,1,4.25,4.249V9a.5.5,0,0,1-.5.5H8.25a.5.5,0,0,1-.5-.5V6.748A4.255,4.255,0,0,1,12,2.5Z']],
  Lock5: ['lock-5', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.75,11.725V6.75a6.75,6.75,0,0,0-13.5,0v4.975a8,8,0,1,0,13.5,0ZM12,18a2,2,0,1,1,2-2A2,2,0,0,1,12,18Zm4.25-9.619a.5.5,0,0,1-.722.448,7.922,7.922,0,0,0-7.056,0,.5.5,0,0,1-.722-.448V6.75a4.25,4.25,0,0,1,8.5,0Z']],
  LockCircle1: ['lock-circle-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.75,8.5a1.75,1.75,0,0,0-3.5,0V10a.25.25,0,0,0,.25.25h3a.25.25,0,0,0,.25-.25Z', 'M20.447,3.477A11.923,11.923,0,0,0,12,0h-.055A12,12,0,0,0,12,24h.056A12,12,0,0,0,20.447,3.477ZM7.5,16.75v-5.5a1,1,0,0,1,1-1h.25V8.5a3.25,3.25,0,0,1,6.5,0v1.75h.25a1,1,0,0,1,1,1v5.5a1,1,0,0,1-1,1h-7A1,1,0,0,1,7.5,16.75Z', 'M10.750 14.500 A1.250 1.250 0 1 0 13.250 14.500 A1.250 1.250 0 1 0 10.750 14.500 Z']],
  Lock4: ['lock-4', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.75,11.725V6.75a6.75,6.75,0,0,0-13.5,0v4.975a8,8,0,1,0,13.5,0Zm-5.75,5V19a1,1,0,0,1-2,0V16.723a2,2,0,1,1,2,0Zm3.25-8.342a.5.5,0,0,1-.722.448,7.922,7.922,0,0,0-7.056,0,.5.5,0,0,1-.722-.448V6.75a4.25,4.25,0,0,1,8.5,0Z']],
  Lock7: ['lock-7', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,19.375H20.75a.25.25,0,0,0-.25.25v2.5a.25.25,0,0,0,.25.25H22a1.5,1.5,0,0,0,0-3Z', 'M19,19.375h0v-.011a1.5,1.5,0,0,0-1.5-1.493H16.75V15.625a.25.25,0,0,0-.25-.25h-2a.25.25,0,0,0-.25.25v2a.25.25,0,0,1-.25.25H6a.25.25,0,0,1-.25-.25V6.875a4.25,4.25,0,0,1,8.5,0v6.75a.25.25,0,0,0,.25.25h2a.25.25,0,0,0,.25-.25V6.875a6.75,6.75,0,0,0-13.5,0v11H1.993A1.5,1.5,0,0,0,.5,19.378h0l.018,3a1.5,1.5,0,0,0,1.5,1.493H17.525a1.466,1.466,0,0,0,1.052-.446A1.49,1.49,0,0,0,19,22.375h0Z']],
  Lock8: ['lock-8', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M16.746 17.500 L21.500 17.500 L21.500 19.500 L16.746 19.500 Z', 'M17,21a1.752,1.752,0,0,1-1.75-1.75v-5A1.752,1.752,0,0,1,17,12.5H21.25a.25.25,0,0,0,.25-.25V11.5a2,2,0,0,0-2-2h-.75V6.75a6.75,6.75,0,0,0-13.5,0V9.5H4.5a2,2,0,0,0-2,2V22a2,2,0,0,0,2,2h15a2,2,0,0,0,2-2v-.75a.25.25,0,0,0-.25-.25ZM7.75,6.75a4.25,4.25,0,0,1,8.5,0V9a.5.5,0,0,1-.5.5H8.25a.5.5,0,0,1-.5-.5Z', 'M16.746 14.000 L21.500 14.000 L21.500 16.000 L16.746 16.000 Z']],
  LockUnlock2: ['lock-unlock-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.75,11.725V6.75a6.75,6.75,0,0,0-13.5,0,1.25,1.25,0,0,0,2.5,0,4.25,4.25,0,0,1,8.5,0V8.381a.5.5,0,0,1-.722.448A7.918,7.918,0,0,0,12,8a8.027,8.027,0,1,0,6.75,3.725Zm-5.75,5V19a1,1,0,0,1-2,0V16.723a2,2,0,1,1,2,0Z']],
  LockNetwork: ['lock-network', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.46,6.975l2.608-2.592a2.208,2.208,0,0,0,.682.117A2.25,2.25,0,1,0,19.5,2.25a2.234,2.234,0,0,0,.134.738L17.05,5.556a1,1,0,1,0,1.41,1.419Z', 'M21.76,19.5a2.205,2.205,0,0,0-.738.135l-2.577-2.588a1,1,0,0,0-1.417,1.412l2.6,2.609A2.244,2.244,0,1,0,21.76,19.5Z', 'M2.25,4.5a2.2,2.2,0,0,0,.681-.117l2.6,2.581A1,1,0,0,0,6.94,5.545L4.366,2.989A2.236,2.236,0,0,0,4.5,2.25,2.25,2.25,0,1,0,2.25,4.5Z', 'M11.989,6.75A2.754,2.754,0,0,0,9.239,9.5v.749h-.25a1,1,0,0,0-1,1V15.5a1,1,0,0,0,1,1h6a1,1,0,0,0,1-1v-4.25a1,1,0,0,0-1-1h-.25V9.5A2.753,2.753,0,0,0,11.989,6.75Zm0,7.749a1,1,0,1,1,1-1A1,1,0,0,1,11.989,14.5Zm0-6.249a1.251,1.251,0,0,1,1.25,1.25V10a.25.25,0,0,1-.25.25h-2a.25.25,0,0,1-.25-.25V9.5A1.252,1.252,0,0,1,11.989,8.25Z', 'M5.545,17.059,2.979,19.635A2.215,2.215,0,0,0,2.24,19.5a2.25,2.25,0,1,0,2.25,2.25,2.227,2.227,0,0,0-.117-.681l2.589-2.6a1,1,0,1,0-1.417-1.411Z', 'M17.989,13.25h1.756a2.25,2.25,0,1,0,0-2H17.989a1,1,0,0,0,0,2Z', 'M5.99,11.25H4.255a2.25,2.25,0,1,0,0,2H5.99a1,1,0,1,0,0-2Z']],
  LockHierarchy: ['lock-hierarchy', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.75,3.25v1H8.5a1,1,0,0,0-1,1V10.5a1,1,0,0,0,1,1h7a1,1,0,0,0,1-1V5.25a1,1,0,0,0-1-1h-.25v-1a3.25,3.25,0,0,0-6.5,0Zm3.25,6a1,1,0,1,1,1-1A1,1,0,0,1,12,9.25ZM12,1.5a1.752,1.752,0,0,1,1.75,1.75V4a.25.25,0,0,1-.25.25h-3A.25.25,0,0,1,10.25,4V3.25A1.752,1.752,0,0,1,12,1.5Z', 'M21.5,19.745v-4.5a1.5,1.5,0,0,0-1.5-1.5H13v-.5a1,1,0,0,0-2,0v.5H4a1.5,1.5,0,0,0-1.5,1.5v4.5a2.25,2.25,0,1,0,2,0v-3.5a.5.5,0,0,1,.5-.5h5.5a.5.5,0,0,1,.5.5v3.5a2.25,2.25,0,1,0,2,0v-3.5a.5.5,0,0,1,.5-.5H19a.5.5,0,0,1,.5.5v3.5a2.25,2.25,0,1,0,2,0Z']],
  LockUnlock: ['lock-unlock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.5,9.5h-.75V6.75A6.751,6.751,0,0,0,5.533,4.811a1.25,1.25,0,1,0,2.395.717A4.251,4.251,0,0,1,16.25,6.75V9a.5.5,0,0,1-.5.5H4.5a2,2,0,0,0-2,2V22a2,2,0,0,0,2,2h15a2,2,0,0,0,2-2V11.5A2,2,0,0,0,19.5,9.5Zm-9.5,6a2,2,0,1,1,3,1.723V19.5a1,1,0,0,1-2,0V17.223A1.994,1.994,0,0,1,10,15.5Z']],
  LockPassword1: ['lock-password-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.5,9.5h-.75V6.75a6.75,6.75,0,0,0-13.5,0V9.5H4.5a2,2,0,0,0-2,2V22a2,2,0,0,0,2,2h15a2,2,0,0,0,2-2V11.5A2,2,0,0,0,19.5,9.5Zm-4,8.5a1,1,0,1,1,1-1A1,1,0,0,1,15.5,18Zm1,2.5a1,1,0,1,1-1-1A1,1,0,0,1,16.5,20.5Zm-1-6a1,1,0,1,1,1-1A1,1,0,0,1,15.5,14.5ZM12,18a1,1,0,1,1,1-1A1,1,0,0,1,12,18Zm1,2.5a1,1,0,1,1-1-1A1,1,0,0,1,13,20.5Zm-1-6a1,1,0,1,1,1-1A1,1,0,0,1,12,14.5ZM8.5,18a1,1,0,1,1,1-1A1,1,0,0,1,8.5,18Zm1,2.5a1,1,0,1,1-1-1A1,1,0,0,1,9.5,20.5Zm-1-6a1,1,0,1,1,1-1A1,1,0,0,1,8.5,14.5ZM7.75,6.75a4.25,4.25,0,0,1,8.5,0V9a.5.5,0,0,1-.5.5H8.25a.5.5,0,0,1-.5-.5Z']],
  LockUnlock4: ['lock-unlock-4', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.75,10.06V6.75a6.75,6.75,0,0,0-13.5,0,1.25,1.25,0,0,0,2.5,0,4.25,4.25,0,0,1,8.5,0V9a.5.5,0,0,1-.5.5H7.5a5.006,5.006,0,0,0-5,5V19a5.006,5.006,0,0,0,5,5h9a5.006,5.006,0,0,0,5-5V14.5A4.988,4.988,0,0,0,18.75,10.06ZM14,16.5a2,2,0,1,1-2-2A2,2,0,0,1,14,16.5Z']],
  LockUnlock3: ['lock-unlock-3', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M18.75,11.725V6.75a6.75,6.75,0,0,0-13.5,0,1.25,1.25,0,0,0,2.5,0,4.25,4.25,0,0,1,8.5,0V8.381a.5.5,0,0,1-.722.448A7.918,7.918,0,0,0,12,8a8.027,8.027,0,1,0,6.75,3.725ZM12,18a2,2,0,1,1,2-2A2,2,0,0,1,12,18Z']],
  LockShield: ['lock-shield', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.75,7.244a1.75,1.75,0,0,0-3.5,0v1.5a.25.25,0,0,0,.25.25h3a.25.25,0,0,0,.25-.25Z', 'M24,1.953A1.959,1.959,0,0,0,22.043.006H1.959A1.958,1.958,0,0,0,.012,1.965L0,9.306A15.145,15.145,0,0,0,11.862,23.975a.974.974,0,0,0,.194.019,1,1,0,0,0,.2-.021A15.145,15.145,0,0,0,23.988,9.2ZM7.5,15.494v-5.5a1,1,0,0,1,1-1h.25V7.244a3.25,3.25,0,0,1,6.5,0v1.75h.25a1,1,0,0,1,1,1v5.5a1,1,0,0,1-1,1h-7A1,1,0,0,1,7.5,15.494Z', 'M10.750 13.244 A1.250 1.250 0 1 0 13.250 13.244 A1.250 1.250 0 1 0 10.750 13.244 Z']],
  KeyholeCircleAlternate: ['keyhole-circle-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm0,22A10,10,0,1,1,22,12,10.011,10.011,0,0,1,12,22Z', 'M12,5a4,4,0,0,0-2.071,7.419l-.746,4.853A1.5,1.5,0,0,0,10.666,19h2.668a1.5,1.5,0,0,0,1.483-1.729l-.747-4.852A4,4,0,0,0,12,5Z']],
  KeyLock: ['key-lock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,6.5h-.5V5a5,5,0,0,0-10,0V6.5a2,2,0,0,0-2,2v4.089a.25.25,0,0,0,.1.2,7.089,7.089,0,0,1,2.187,2.54.251.251,0,0,0,.223.137h5.919a3.012,3.012,0,0,1,3.049,2.771.249.249,0,0,0,.249.232H22a2,2,0,0,0,2-2V8.5A2,2,0,0,0,22,6.5ZM13.5,5a3,3,0,0,1,6,0V6.25a.25.25,0,0,1-.25.25h-5.5a.25.25,0,0,1-.25-.25Zm4,7.263v1.208a.75.75,0,0,1-1.5,0V12.263a1.5,1.5,0,1,1,1.5,0Z', 'M19.5,18.406a1.547,1.547,0,0,0-1.566-1.438h-7.1a5.541,5.541,0,0,0-5.3-4.018c-.169,0-.341.008-.513.024A5.6,5.6,0,0,0,0,18.46,5.525,5.525,0,0,0,5.524,24H5.55a5.5,5.5,0,0,0,5.293-4.013l.51,0a.248.248,0,0,1,.219.127l.935,1.659a.5.5,0,0,0,.859.021L14.427,20.1a.248.248,0,0,1,.209-.116l.217,0a.254.254,0,0,1,.22.126l.945,1.653a.5.5,0,0,0,.858.017L18,19.982v0A1.507,1.507,0,0,0,19.5,18.406Zm-15,1.319a1.25,1.25,0,1,1,1.25-1.25A1.25,1.25,0,0,1,4.5,19.725Z']],
  KeyholeSquareAlternate: ['keyhole-square-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.429,0H2.571A2.573,2.573,0,0,0,0,2.571V21.429A2.573,2.573,0,0,0,2.571,24H21.429A2.573,2.573,0,0,0,24,21.429V2.571A2.573,2.573,0,0,0,21.429,0ZM22,21.429a.579.579,0,0,1-.571.571H2.571A.579.579,0,0,1,2,21.429V2.571A.579.579,0,0,1,2.571,2H21.429A.579.579,0,0,1,22,2.571Z', 'M16.167,9.135a4.167,4.167,0,0,0-8.334,0,4.092,4.092,0,0,0,2,3.526l-1.172,5A1.5,1.5,0,0,0,10.119,19.5h3.762a1.5,1.5,0,0,0,1.46-1.843l-1.172-5A4.092,4.092,0,0,0,16.167,9.135Z']],
  DoorLock: ['door-lock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.25,2a2,2,0,0,0-2-2H6.75a2,2,0,0,0-2,2V3a1,1,0,0,0,2,0V2.5a.5.5,0,0,1,.5-.5h12.5a.5.5,0,0,1,.5.5v19a.5.5,0,0,1-.5.5H7.25a.5.5,0,0,1-.5-.5V20a1,1,0,0,0-2,0v2a2,2,0,0,0,2,2h13.5a2,2,0,0,0,2-2Z', 'M10.25,18a1.5,1.5,0,0,0,1.5-1.5v-5a1.5,1.5,0,0,0-1.5-1.5V8.75a3.5,3.5,0,0,0-7,0V10a1.5,1.5,0,0,0-1.5,1.5v5A1.5,1.5,0,0,0,3.25,18Zm-3.5-4.75a1,1,0,1,1-1,1A1,1,0,0,1,6.75,13.25Zm-1.5-4.5a1.5,1.5,0,0,1,3,0v1A.25.25,0,0,1,8,10H5.5a.25.25,0,0,1-.25-.25Z']],
  HandGiveLock: ['hand-give-lock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.5,19.5H6.375a.625.625,0,0,1,0-1.25H8.9a1,1,0,0,0,.92-1.394A2.234,2.234,0,0,0,7.764,15.5H3.5A.5.5,0,0,0,3,16v6.5a.5.5,0,0,0,.5.5H14.264A2.238,2.238,0,0,0,16.5,20.764V20.5A1,1,0,0,0,15.5,19.5Z', 'M1,14.75a1,1,0,0,0-1,1V23a1,1,0,0,0,2,0V15.75A1,1,0,0,0,1,14.75Z', 'M22.245,5.835a.256.256,0,0,1-.256-.255V4.139a4.138,4.138,0,1,0-8.276,0V5.58a.255.255,0,0,1-.255.255A1.758,1.758,0,0,0,11.7,7.591v6.9a1.757,1.757,0,0,0,1.756,1.755h8.787A1.757,1.757,0,0,0,24,14.5v-6.9A1.758,1.758,0,0,0,22.245,5.835Zm-4.394,7.09a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,17.851,12.925Zm2.138-7.59a.5.5,0,0,1-.5.5H16.213a.5.5,0,0,1-.5-.5v-1.2a2.138,2.138,0,1,1,4.276,0Z']],
  Lock2: ['lock-2', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.5,9.5h-.75V6.75a6.75,6.75,0,0,0-13.5,0V9.5H4.5a2,2,0,0,0-2,2V22a2,2,0,0,0,2,2h15a2,2,0,0,0,2-2V11.5A2,2,0,0,0,19.5,9.5Zm-7.5,9a2,2,0,1,1,2-2A2,2,0,0,1,12,18.5ZM16.25,9a.5.5,0,0,1-.5.5H8.25a.5.5,0,0,1-.5-.5V6.75a4.25,4.25,0,0,1,8.5,0Z']],
  LockUnlock1: ['lock-unlock-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.5,9.5h-.75V6.75A6.751,6.751,0,0,0,5.533,4.811a1.25,1.25,0,1,0,2.395.717A4.251,4.251,0,0,1,16.25,6.75V9a.5.5,0,0,1-.5.5H4.5a2,2,0,0,0-2,2V22a2,2,0,0,0,2,2h15a2,2,0,0,0,2-2V11.5A2,2,0,0,0,19.5,9.5Zm-7.5,9a2,2,0,1,1,2-2A2,2,0,0,1,12,18.5Z']],
  Lock3: ['lock-3', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15,16.5a.5.5,0,0,1,0-1h.449A3.485,3.485,0,0,0,12.5,12.551V13a.5.5,0,0,1-1,0v-.449A3.485,3.485,0,0,0,8.551,15.5H9a.5.5,0,0,1,0,1H8.551A3.485,3.485,0,0,0,11.5,19.449V19a.5.5,0,0,1,1,0v.449A3.485,3.485,0,0,0,15.449,16.5ZM12,17a1,1,0,1,1,1-1A1,1,0,0,1,12,17Z', 'M18.75,11.725V6.75a6.75,6.75,0,0,0-13.5,0v4.975a8,8,0,1,0,13.5,0ZM12.5,21a.5.5,0,0,1-1,0v-.551A4.474,4.474,0,0,1,7.551,16.5H7a.5.5,0,0,1,0-1h.551A4.474,4.474,0,0,1,11.5,11.551V11a.5.5,0,0,1,1,0v.551A4.474,4.474,0,0,1,16.449,15.5H17a.5.5,0,0,1,0,1h-.551A4.474,4.474,0,0,1,12.5,20.449ZM12,2.5a4.255,4.255,0,0,1,4.25,4.25V8.381a.5.5,0,0,1-.722.448,7.922,7.922,0,0,0-7.056,0,.5.5,0,0,1-.722-.448V6.75A4.255,4.255,0,0,1,12,2.5Z']],
  TouchFingerLock: ['touch-finger-lock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M19.879,17H16.75a.25.25,0,0,1-.25-.25V10.375a1.875,1.875,0,0,0-3.75,0v8.808a.5.5,0,0,1-.908.29L10.469,17.54a1.575,1.575,0,0,0-2.787,1.467l1.972,4.687a.5.5,0,0,0,.461.306H23.5a.5.5,0,0,0,.5-.5V21.347A4.332,4.332,0,0,0,19.879,17Z', 'M11,11V8a1.491,1.491,0,0,0-.643-1.223.249.249,0,0,1-.107-.205V6a2.75,2.75,0,0,0-5.5,0v.572a.25.25,0,0,1-.107.205A1.491,1.491,0,0,0,4,8v3a1.5,1.5,0,0,0,1.5,1.5h4A1.5,1.5,0,0,0,11,11Zm-3.5-.48a1,1,0,1,1,1-1A1,1,0,0,1,7.5,10.52ZM8.75,6.25a.25.25,0,0,1-.25.25h-2a.25.25,0,0,1-.25-.25V6a1.25,1.25,0,0,1,2.5,0Z', 'M3,13H2.5a.5.5,0,0,1-.5-.5V2.5A.5.5,0,0,1,2.5,2h10a.5.5,0,0,1,.5.5V6a1,1,0,0,0,2,0V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V13a2,2,0,0,0,2,2H3a1,1,0,0,0,0-2Z']],
  Lock: ['lock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.652,21.5H2.5V15.348a1.25,1.25,0,0,0-2.5,0v6.4A2.252,2.252,0,0,0,2.25,24h6.4a1.249,1.249,0,1,0,0-2.5Z', 'M1.25,9.9A1.25,1.25,0,0,0,2.5,8.652V2.5H8.652a1.25,1.25,0,1,0,0-2.5H2.25A2.252,2.252,0,0,0,0,2.249v6.4A1.25,1.25,0,0,0,1.25,9.9Z', 'M22.75,14.1a1.25,1.25,0,0,0-1.25,1.249V21.5H15.348a1.249,1.249,0,1,0,0,2.5h6.4A2.252,2.252,0,0,0,24,21.752v-6.4A1.25,1.25,0,0,0,22.75,14.1Z', 'M21.75,0h-6.4a1.25,1.25,0,1,0,0,2.5H21.5V8.652a1.25,1.25,0,0,0,2.5,0v-6.4A2.252,2.252,0,0,0,21.75,0Z', 'M12,3.763A4.482,4.482,0,0,0,7.5,8.216v.825H7.125A1.618,1.618,0,0,0,5.5,10.65v7.244A1.618,1.618,0,0,0,7.125,19.5h9.75A1.618,1.618,0,0,0,18.5,17.894V10.65a1.618,1.618,0,0,0-1.625-1.609H16.5V8.216A4.482,4.482,0,0,0,12,3.763ZM9.5,8.216a2.5,2.5,0,0,1,5,0v.825h-5Zm2.5,6.79a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,12,15.006Z']],
  LockCircle: ['lock-circle', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.75,8.5a1.75,1.75,0,0,0-3.5,0V10a.25.25,0,0,0,.25.25h3a.25.25,0,0,0,.25-.25Z', 'M11.946,0A12,12,0,1,0,24,11.946,12.013,12.013,0,0,0,11.946,0ZM7.5,16.751v-5.5a1,1,0,0,1,1-1h.25V8.5a3.25,3.25,0,0,1,6.5,0v1.75h.25a1,1,0,0,1,1,1v5.5a1,1,0,0,1-1,1h-7A1,1,0,0,1,7.5,16.751Z', 'M10.750 14.501 A1.250 1.250 0 1 0 13.250 14.501 A1.250 1.250 0 1 0 10.750 14.501 Z']],
  KeyLock1: ['key-lock-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M24,8.5a2,2,0,0,0-2-2h-.5V5a5,5,0,0,0-10,0V6.5a2,2,0,0,0-2,2v4.089a.25.25,0,0,0,.1.2,7.089,7.089,0,0,1,2.187,2.54.251.251,0,0,0,.223.137h5.919a3.012,3.012,0,0,1,3.049,2.771.249.249,0,0,0,.249.232H22a2,2,0,0,0,2-2ZM13.5,5a3,3,0,0,1,6,0V6.25a.25.25,0,0,1-.25.25h-5.5a.25.25,0,0,1-.25-.25Zm3.25,8.5a1.75,1.75,0,1,1,1.75-1.75A1.75,1.75,0,0,1,16.75,13.5Z', 'M19.5,18.406a1.547,1.547,0,0,0-1.566-1.438h-7.1a5.54,5.54,0,0,0-5.3-4.018A5.587,5.587,0,0,0,0,18.46a5.527,5.527,0,0,0,10.843,1.527l.51,0a.248.248,0,0,1,.219.127l.935,1.659a.5.5,0,0,0,.859.021L14.427,20.1a.248.248,0,0,1,.21-.116l.216,0a.254.254,0,0,1,.22.126l.945,1.653a.5.5,0,0,0,.858.017L18,19.982v0A1.507,1.507,0,0,0,19.5,18.406Zm-15,1.319a1.25,1.25,0,1,1,1.25-1.25A1.25,1.25,0,0,1,4.5,19.725Z']],
  DoorPasswordLock: ['door-password-lock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M.5,11.5h11A.5.5,0,0,0,12,11V3.5A3.5,3.5,0,0,0,8.5,0h-5A3.5,3.5,0,0,0,0,3.5V11A.5.5,0,0,0,.5,11.5Zm9-8a1,1,0,1,1-1,1A1,1,0,0,1,9.5,3.5ZM9.5,7a1,1,0,1,1-1,1A1,1,0,0,1,9.5,7ZM6,3.5a1,1,0,1,1-1,1A1,1,0,0,1,6,3.5ZM6,7A1,1,0,1,1,5,8,1,1,0,0,1,6,7ZM2.5,3.5a1,1,0,1,1-1,1A1,1,0,0,1,2.5,3.5ZM2.5,7a1,1,0,1,1-1,1A1,1,0,0,1,2.5,7Z', 'M11.482,21.5H6a3,3,0,0,1,0-6h5.75a.25.25,0,0,0,.25-.25V13.5a.5.5,0,0,0-.5-.5H.5a.5.5,0,0,0-.5.5v7A3.5,3.5,0,0,0,3.5,24h5a3.486,3.486,0,0,0,3.213-2.154.25.25,0,0,0-.231-.346Z', 'M21.019,17.862l-1.037-.3A14.74,14.74,0,0,0,15.939,17H6a1.5,1.5,0,0,0,0,3h9.939a14.74,14.74,0,0,0,4.043-.566l1.037-.3a.663.663,0,0,0,0-1.275Z']]
};
exports["default"] = _default;